import React, { useEffect, useState } from "react";
import Header from "../../../../../Componets/Header";
import Table from "../../../../../Componets/Table";
import Status from "../../../../../Componets/Status";
import Loadercomponent from "../../../../../Componets/Loader";
import { get_all_accounts } from "../../../../../Controllers/Accounting/Services/chartOfAccountsService";
import toast from "react-hot-toast";
import tables from "../../../../../Data/Tables/Accounting/ChartOfAccounts/tables";
import headers from "../../../../../Data/Tables/Accounting/ChartOfAccounts/headers";

const ChartOfAccounts = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};

    header?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
    });
  };

  const formdata = (data) => {

    let page = data?.search ? pagination?.currentPage : 1;

    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        page: tabledata?.currentPage,
        limit: 10, 
        isGetAll:true
      };

      const response = await get_all_accounts(data);

      

      if (response?.data) {
        const paginatedData = response.data;
        
        const tableBody = paginatedData.map((account) => ({
          "Account Name": account?.name,
          Code: account?.code,
          Type: account?.type,
          Category: account?.category,
          Status: <Status status={account?.status} />,
          Balance:
            account?.balance === 0
              ? 0
              : account?.balance < 0
              ? `-${Math.abs(account?.balance).toLocaleString()}`
              : `${Math.abs(account?.balance).toLocaleString()}`,
        }));

        setBody(tableBody);

        setPagination({
          currentPage: response.currentPage,
          totalCount: response.totalCount,
          totalPages: response.totalPages,
        });

        setLoader(false);
      } else {
        setLoader(false);
        toast.error("Failed to load accounts");
      }
    } catch (error) {
      setLoader(false);
      console.error("Failed to load accounts:", error.message);
      toast.error(error.message);
    }
  };


  const headerReset = () => {
    let componentData = [];
    headers?.components?.map((value, index) => {
      componentData?.push({
        ...value,
        value: null,
      });
    });
    setHeader({ ...headers, components: componentData });
  };

  useEffect(() => {
    fetchData();
    headerReset();
  }, []);

  return (
    <Header
      headers={header}
      setHeaders={setHeader}
      formdata={formdata}
      title="Chart of Accounts"
    >
      <Loadercomponent loader={loader}>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
        />
      </Loadercomponent>
    </Header>
  );
};

export default ChartOfAccounts;
